import React from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import EraseButton from "../../../../../components/input/eraseButton";
import InputColor from "../../../../../components/input/inputColor";
import {
  qrPatternColor,
  resetQrPatternColor,
} from "../../../../../redux/slices/qrSettings";

const QrPatternSingleColor = () => {
  const patternColor = useSelector((state) => state.qrSettings.patternColor);

  const dispatch = useDispatch();

  return (
    <Row className="gx-3">
      <Col xs="auto" style={{ width: 188 }}>
        <InputColor
          value={patternColor}
          onChange={(color) => dispatch(qrPatternColor(color))}
          className="mb-0"
        />
      </Col>
      <Col xs="auto">
        <EraseButton
          className="h-100"
          onClick={() => dispatch(resetQrPatternColor())}
        />
      </Col>
    </Row>
  );
};

export default QrPatternSingleColor;
